module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0106.jpg?v=e88435f4";